enum AddToListStateEnum {
	default = 'default',
	loading = 'loading',
	confirmation = 'confirmation'
}

export default AddToListStateEnum;
